<template>
  <section class="app-main">
    <!-- {{ cachedViews }} --- 12 --- {{ key }} -->
    <transition
      name="fade-transform"
      mode="out-in"
      v-if="showWatermark"
      ref="watermarkContainer"
    >
      <router-view :key="key" />
    </transition>
    <transition
      name="fade-transform"
      mode="out-in"
     v-else
    >
      <router-view :key="key" />
    </transition>
    <!-- <transition :name="transitionName" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition> -->
  </section>
</template>

<script>
import watermark from "watermark-package";
// watermark.setWaterMark({
//   w_texts: ["MSK模拟盘"],
//   w_options: {
//     w_width: 480,
//     w_height: 280,
//     w_top: "0px",
//     w_left: "0px",
//     w_rotateDeg: 25,
//     w_font: "1.2rem Vedana",
//     w_color: "#666",
//     w_opacity: "0.2",
//     w_zIndex: "100000",
//   },
// });
export default {
  name: "AppMain",
  data() {
    return {
      state: false,
      text:"MSK模拟盘",
      showWatermark: false // 水印开关
    };
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
    transitionName() {
      return !this.state ? "" : "fade-transform";
    },
  },
  created() {
    const domainUrl = window.location.hostname
    // console.log(domainUrl);
    // if (domainUrl == 'localhost') {
    if (domainUrl == 'www.osmsc.top') {
      this.showWatermark = true
    }
    if (this.showWatermark) {
      this.addWatermark();
    }
  },
  methods: {
    toggleWatermark() {
      this.showWatermark = !this.showWatermark;
      if (this.showWatermark) {
        this.addWatermark();
      } else {
        this.removeWatermark();
      }
    },
    addWatermark() {
      // 添加水印
      watermark.setWaterMark({
        w_texts: [this.text],
        w_options: {
          w_width: 480,
          w_height: 280,
          w_top: "0px",
          w_left: "0px",
          w_rotateDeg: 25,
          w_font: "1.2rem Vedana",
          w_color: "#666",
          w_opacity: "0.2",
          w_zIndex: "100000",
        },
      });
    },
    removeWatermark() {
      watermark.removeWatermark(); // Assuming the plugin provides a method to remove watermark
    }
  },
  beforeDestroy() {
    this.removeWatermark();
  }

};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  // background-color: #f2f2f2;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
.app-main {
  padding: 10px;
}
</style>
